import { ChangeDetectionStrategy, Component } from '@angular/core';
import { IPermission } from 'src/app/shared/guards/authorized.guard';
import { OperationEnum } from 'src/app/utils/enums/operation.enums';

@Component({
  selector: 'xpac-service',
  templateUrl: './service.component.html',
  styleUrls: ['./service.component.scss'],  
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ServiceComponent {

  public agGetRequiredPermissions(): IPermission[] {
    return [
      { type: 'Device_Connections', operation: OperationEnum.READ }
    ];
  }

}
